import { useEffect } from 'react';
import { Toaster as RHToaster, toast, useToasterStore } from 'react-hot-toast';

const TOAST_LIMIT = 3;

function Toaster() {
  const { toasts } = useToasterStore();

  useEffect(() => {
    toasts
      .filter((t) => t.visible)
      .filter((_, i) => i >= TOAST_LIMIT)
      .forEach((t) => toast.dismiss(t.id));
  }, [toasts]);

  return (
    <RHToaster
      position="bottom-left"
      containerStyle={{ left: '4rem' }}
      gutter={6}
    />
  );
}

export default Toaster;
